import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import animations from 'src/styles/animations';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), animations.textLoading), {}, {
  title: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    '& img': {
      marginLeft: '4px'
    }
  },
  glAccount: {
    marginTop: '40px'
  },
  glAccountItem: {
    display: 'block !important',
    '& i': {
      display: 'block',
      fontSize: '11px',
      fontStyle: 'normal'
    }
  },
  addBillingTemplate: {
    marginTop: '32px',
    '& > .MuiButtonBase-root': {
      padding: '12px',
      fontSize: '15px'
    }
  },
  list: {
    marginTop: '40px'
  },
  listItem: {
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    '&:not(:last-child)': {
      marginBottom: '40px'
    }
  },
  listItemHeader: {
    display: 'flex',
    padding: '20px 40px',
    alignItems: 'flex-start',
    background: palette.brandGradients.fade
  },
  listItemHeaderData: {
    width: '100%'
  },
  listItemHeaderDataTitle: {
    fontSize: '22px',
    fontWeight: '600'
  },
  listItemHeaderDataCaption: {
    fontSize: '15px',
    fontWeight: '600',
    color: "".concat(palette.shades[600]),
    lineHeight: '1'
  },
  listItemHeaderActions: {
    display: 'flex',
    flexShrink: '0',
    marginLeft: '24px',
    alignItems: 'center'
  },
  listItemHeaderActionsItem: {
    '&:not(:last-child)': {
      marginRight: '4px'
    },
    '& .MuiButtonBase-root': {
      padding: '8px'
    },
    '&.status .MuiButtonBase-root': {
      border: '1px solid transparent',
      '& .MuiSvgIcon-root path': {
        fill: "".concat(palette.primary.main)
      }
    }
  },
  listItemBody: {
    padding: '5px 15px 15px 15px',
    '&.newAutoBilling': {
      '& > div': {
        alignItems: 'flex-start',
        background: palette.brandGradients.main
      },
      '& .newAutoBillingDetailText': {
        color: "".concat(palette.shades[100]),
        '&:last-child': {
          fontSize: '14px'
        }
      }
    }
  },
  listItemBodyContent: {
    display: 'flex',
    borderRadius: '2px',
    padding: '20px 15px',
    alignItems: 'center',
    border: "1px solid ".concat(palette.shades[300])
  },
  listItemBodyIcon: {
    width: '48px',
    height: '48px',
    flexShrink: '0',
    display: 'flex',
    marginRight: '16px',
    borderRadius: '2px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "".concat(palette.shades[200]),
    '& .MuiSvgIcon-root path': {
      fill: "".concat(palette.primary.main)
    },
    '&.error': {
      '& .MuiSvgIcon-root path': {
        fill: "".concat(palette.error.main)
      }
    }
  },
  listItemBodyDetails: {
    width: '100%'
  },
  listItemBodyDetailsTitle: {
    lineHeight: '1',
    fontSize: '18px',
    fontWeight: '600'
  },
  listItemBodyDetailsCaption: {
    fontSize: '16px',
    fontWeight: '600',
    color: "".concat(palette.shades[700]),
    lineHeight: '1.2',
    marginTop: '4px',
    '&.loading': {
      color: "".concat(palette.shades[500])
    },
    '&.error': {
      color: "".concat(palette.error.main)
    },
    '& span': {
      animation: '$text-loading 1.4s infinite',
      animationFillMode: 'both',
      '&:nth-child(2)': {
        animationDelay: '.2s'
      },
      '&:nth-child(3)': {
        animationDelay: '.4s'
      }
    }
  },
  listItemBodyActions: {
    flexShrink: '0',
    display: 'flex',
    marginLeft: '20px',
    alignItems: 'center'
  },
  listItemBodyAction: {
    '&:not(:last-child)': {
      marginRight: '12px'
    }
  },
  billingAutomationSetupIcon: {
    '& .MuiSvgIcon-root path': {
      fill: "".concat(palette.primary.main)
    }
  },
  autoBillingTrigger: {
    '&.activated': {
      border: "1px solid ".concat(palette.success.main),
      background: palette.success.light,
      '&:hover': {
        background: '#D4F0D5'
      },
      '& .MuiTypography-root': {
        color: "".concat(palette.success.main)
      },
      '& .MuiSvgIcon-root path': {
        fill: "".concat(palette.primary.main)
      }
    },
    '&.error': {
      border: "1px solid ".concat(palette.error.main),
      background: palette.error.light,
      '&:hover': {
        background: '#F6D2DB'
      },
      '& .MuiTypography-root': {
        color: "".concat(palette.error.main)
      },
      '& .MuiSvgIcon-root path': {
        fill: "".concat(palette.error.main)
      }
    }
  },
  glLoader: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '999',
    display: 'flex',
    fontSize: '18px',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.9)'
  }
}));
export default useStyles;